import axios from "axios";
import { IDeliveryRequest } from "../../deliveryModule/Types/delivery.interfaces";

// Your server mounts the router at /api/delivery (singular)
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/delivery`;

export const fetchAvailableDeliveries = async (
  userId: string,
  role: "sender" | "driver"
): Promise<IDeliveryRequest[]> => {
  const res = await axios.get(`${BASE_URL}`, {
    params: { userId, role },
  });
  return res.data;
};

export const requestDelivery = async (
  payload: Partial<IDeliveryRequest>
): Promise<IDeliveryRequest> => {
  const res = await axios.post(`${BASE_URL}`, payload);
  return res.data;
};

export const acceptDelivery = async (
  deliveryId: string,
  driverId: string
): Promise<IDeliveryRequest> => {
  const res = await axios.post(`${BASE_URL}/${deliveryId}/accept`, {
    driverId,
  });
  return res.data;
};

export const fetchDeliveryById = async (
  id: string
): Promise<IDeliveryRequest> => {
  const res = await axios.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const updateDeliveryStatus = async (
  id: string,
  status:
    | "requested"
    | "accepted"
    | "assigned"
    | "in_transit"
    | "delivered"
    | "cancelled",
  note?: string
): Promise<IDeliveryRequest> => {
  const res = await axios.patch(`${BASE_URL}/${id}/status`, { status, note });
  return res.data;
};
